import { combineReducers } from "@reduxjs/toolkit";
import applicationSlice from "./applicationSlice";
import userSlice from "./userSlice";
import leadSlice from "./leadSlice";
import dashboardSlice from "./dashboardSlice";
import adminSlice from "./adminSlice";
import customerSlice from "./customerSlice";
import servicesSlice from "./servicesSlice";
import invoiceSlice from "./invoiceSlice";
import resourceSlice from "./resourcesSlice";
import appSlice from "./appSlice";
import calendarSlice from "./calendarSlice";
import communicationSlice from "./communicationSlice";
import leadReportSlice from "./leadReportSlice";
import revenueReportSlice from "./revenueReportSlice";
import invoiceReportSlice from "./invoiceReportSlice";
import referenceSlice from "./referenceSlice";
import weeklyReportSlice from "./WeeklyReportSlice";
import freshToEnquirySlice from "./FreshToEnquirySlice";
import enquiryToCustomerSlice from "./EnquiryToCustomerSlice";
import monthlyLeadsSlice from "./MonthlyLeadsSlice";
import sourceConversionReportSlice from "./sourceConversionReportSlice";
import monthlyRevenueSlice from "./MonthlyRevenueSlice";
import totalRevenueReportSlice from "./totalRevenueSlice";
import invoiceCountReportSlice from "./invoiceCountReportSlice";
import invoicePendingCountSlice from "./invoicePendingCountSlice";
import countrywiseRevenueSlice from "./countrywiseRevenueSlice";
import serviceRevenueSlice from "./serviceRevenueSlice";
import pendingDuesSlice from "./pendingAmountsSlice";
import partialInvoiceCountSlice from "./partialInvoiceSlice";
import categorywiseRevenueSlice from "./levelRevenueSlice";
import adminleadReportSlice from "./adminReportSlice";
import reminderSlice from "./reminderSlice";
import messagesSlice from "./messagesSlice";
import manageDetailsSlice from "./manageDetailsSlice";
import postServiceStudentSlice from "./postServiceStudentSlice";

const rootReducer = combineReducers({
  application: applicationSlice,
  user: userSlice,
  leads: leadSlice,
  dashboard: dashboardSlice,
  admin: adminSlice,
  customer: customerSlice,
  service: servicesSlice,
  invoice: invoiceSlice,
  resources: resourceSlice,
  app: appSlice,
  calendar: calendarSlice,
  communication: communicationSlice,
  reports: leadReportSlice,
  revenueReport: revenueReportSlice,
  invoiceReport: invoiceReportSlice,
  reference: referenceSlice,
  weeklyReport: weeklyReportSlice,
  freshToEnquiry: freshToEnquirySlice,
  enquiryToCustomer: enquiryToCustomerSlice,
  monthlyLeads: monthlyLeadsSlice,
  sourceConversionReport: sourceConversionReportSlice,
  monthlyRevenue: monthlyRevenueSlice,
  totalRevenueReport: totalRevenueReportSlice,
  invoiceCountReport: invoiceCountReportSlice,
  invoicePendingReport: invoicePendingCountSlice,
  countrywiseRevenue: countrywiseRevenueSlice,
  servicewiseRevenue: serviceRevenueSlice,
  pendingDuesReport: pendingDuesSlice,
  partialInvoiceCountReport: partialInvoiceCountSlice,
  categorywiseRevenue: categorywiseRevenueSlice,
  leadReportAdmin: adminleadReportSlice,
  reminders: reminderSlice,
  messages: messagesSlice,
  manageDetails: manageDetailsSlice,
  postServiceStudents: postServiceStudentSlice,
});

export default rootReducer;
